import React from "react";

import { GlobalContext } from "../../../utils/globalprovider.js";
import "./confmanager.css"

class OneConf extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    onClick()
    {
        if (this.props.onclick) this.props.onclick(this.props.conf)
    }

    formatDate(dateStr) {
        const date = new Date(dateStr.replace(/\//g, "-"));
        const form = this.context.language=="fr"?"fr-FR":"en-GB";
        return date.toLocaleDateString(form, {
            day: "numeric",
            month: "long",
            year: "numeric"
        });
    }

    format4(n) {
        return String(n).padStart(4, "0");
    }

    render()
    {

        var listconfigitem = "ListConfigItem";
        var listconfigitemline1 = "ListConfigItemLine1Even";
        var listconfigitemline2 = "ListConfigItemLine2Even";

        
         
        if (this.props.conf.coid === this.props.selected)
        {
            listconfigitemline1 = "ListConfigItemLine1Selected";
            listconfigitemline2 = "ListConfigItemLine2Selected";

        }
        else
        {
            if ((this.props.index & 1 ) === 1)
            {
                
                listconfigitemline1 = "ListConfigItemLine1Odd";
                listconfigitemline2 = "ListConfigItemLine2Odd";

            }
        }

        return (
            <div className = {listconfigitem} 
                onClick = {this.onClick} >
                <div className = {listconfigitemline1} >
                    {this.format4(this.props.conf.coid)}&nbsp;{this.props.conf.coname}
                </div>
                <div className = {listconfigitemline2} >
                    {this.formatDate(this.props.conf.coupdatedate)}
                </div>
            </div>
        )

    }
}

class ListConfig extends React.Component
{
    static contextType = GlobalContext;
    constructor(props)
    {
        super (props);
        this.onClick = this.onClick.bind(this);
    }

    onClick (datas)
    {
        
        if (this.props.onselect)
            this.props.onselect(datas.coid, datas)
        
    }

    

    render()
    {

    var liste = [];

    


    this.props.list.forEach((element, index) => {
        
        liste.push (
            <OneConf
                selected = {this.props.selected}
                conf = {element}
                onclick = {this.onClick}
                index = {index}
            />
        )
    });
    return (
        <div className="ListConfigMain" style={{height: this.props.height}}>
            {liste}

        </div>
    );    
    }
}


ListConfig.defaultProps = 
{ 
    selected : -1,
    list: [],
    height: 200,
}

export default ListConfig;
